import Model from './Model';

class NewsletterModel extends Model {
    static attributes = {
        email: 'email',
    };
}

export default NewsletterModel;
